<template>
  <nav
    class="main-nav-menu"
  >
    <div v-for="ns in navSections"
      :key="ns.menuName"
    >
      <div
        :class="ns.class"
        v-if="hasPermission(ns.permissionKey)"
      >
        <div
          class="nav-section-label"
        >
          {{ns.menuName}}
        </div>
        <router-link
          v-for="r in filteredRoutes(ns.routes)"
          :key="r.menuName"
          :to="{ name: r.routeName }"
          :class="r.class"
          :exact="r.exact"
        >
          <div class="nav-label">
            {{r.menuName}}
          </div>
        </router-link>
      </div>
    </div>

  </nav>
</template>

<script>
import script from './script/index'
export default script
</script>
<style lang="scss" src="./style/_styles.scss" scoped />
